import { useNavigate } from 'react-router-dom'
import { Form } from 'react-bootstrap'
import AuthApiManager from '../../api/services/AuthApiManager'
import { jwtDecode } from 'jwt-decode'
import { ToastContainer, toast } from 'react-toastify'
import { useEffect, useState } from 'react'
import OperatorsApiManager from '../../api/services/OperatorsApiManager'
import UserApiManager from '../../api/services/UserApiManager'
import { useTranslation } from 'react-i18next'

function Login() {
    const navigate = useNavigate()
    const { t, i18n } = useTranslation();
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [showPassword, setShowPassword] = useState(false) // Estado para alternar visibilidad

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword)
    }
    useEffect(() => {
        const userData = localStorage.getItem('userData')
        if (userData) {
            const { tokenExpiration } = JSON.parse(userData)
            if (tokenExpiration > Date.now() / 1000) {
                navigate('/operadores')
            }
        }
    }, [])

    async function ingresar() {
        if (username === '' || password === '') {
            toast.error(t('validations.user_pass_required'))
            return
        }

        var response = await AuthApiManager.authToken({
            username: username,
            password: password,
        }).catch((error) => {
            console.error(error)
            toast.error(error.error_description)
        })

        if (response) {
            toast.success(t('alerts.login_success'))

            const decoded = jwtDecode(response.access_token)

            var userData = {
                userId: decoded.sub,
                tokenExpiration: decoded.exp,
                tokenResponse: response,
                username: username,
            }

            localStorage.setItem('userData', JSON.stringify(userData))

            const userDataApi = await UserApiManager.getUser()

            if (userDataApi) {
                const data = userDataApi
                var userData = {
                    userId: decoded.sub,
                    tokenExpiration: decoded.exp,
                    tokenResponse: response,
                    username: username,
                    avatar: data.user_picture[0]?.url,
                }
                localStorage.setItem('userData', JSON.stringify(userData))
            }

            const operatorv1Items =
                await OperatorsApiManager.getUserOperatorsV1()

            const operatorV1 = operatorv1Items[0]

            var operatorToSave = {
                group_id: operatorV1.operador,
                group_name: operatorV1.nombre_operador,
                role: operatorV1.group_roles,
            }

            localStorage.setItem('operador', JSON.stringify(operatorToSave))

            navigate('/operadores')
        }
    }

    return (
        <>
            <div className="d-flex align-items-center auth px-0">
                <ToastContainer />
                <div className="row w-100 mx-0">
                    <div className="col-lg-4 mx-auto">
                        <div className="auth-form-light text-start py-5 px-4 px-sm-5">
                            <div className="text-center brand-logo">
                                <div className="brand-logo">
                                    <img
                                        src="/images/OkTvNegro.png"
                                        alt="logo"
                                    />
                                </div>
                                <h4>{t('app.welcome_message')}</h4>
                                <h6 className="fw-light">
                                    {t('app.login_description')}
                                </h6>
                            </div>

                            <Form className="pt-3">
                                <Form.Group className="d-flex search-field">
                                    <Form.Control
                                        type="email"
                                        placeholder={t('auth.login.username')}
                                        size="lg"
                                        value={username}
                                        onChange={(e) =>
                                            setUsername(e.target.value)
                                        }
                                        className="h-auto"
                                    />
                                </Form.Group>
                                <Form.Group className="d-flex search-field">
                                    <Form.Control
                                        type={
                                            showPassword ? 'text' : 'password'
                                        }
                                        placeholder={t('auth.login.password')}
                                        value={password}
                                        onChange={(e) =>
                                            setPassword(e.target.value)
                                        }
                                        size="lg"
                                        className="h-auto"
                                    >
                                    </Form.Control>
                                        <span
                                            onClick={togglePasswordVisibility}
                                            style={{
                                                marginLeft: '10px',
                                                marginBottom: '10px',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            {showPassword ? (
                                                <i
                                                    className="mdi mdi-eye-off"
                                                    style={{
                                                        fontSize: '20px',
                                                        color: '#6c757d',
                                                    }}
                                                ></i>
                                            ) : (
                                                <i
                                                    className="mdi mdi-eye"
                                                    style={{
                                                        fontSize: '20px',
                                                        color: '#6c757d',
                                                    }}
                                                ></i>
                                            )}
                                        </span>
                                </Form.Group>
                                <div className="mt-3 d-grid gap-2">
                                    <button
                                        type="button"
                                        className="btn btn-primary btn-lg fw-medium"
                                        onClick={ingresar}
                                    >
                                        {t('button.login')}
                                    </button>
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Login
